module.exports = __webpack_public_path__ + "img/MapThumb_KingOfTheHill.6e002d07.webp";